import { render, staticRenderFns } from "./ThemeSwitcher.vue?vue&type=template&id=0eb4974a&scoped=true"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ThemeSwitcher.vue?vue&type=style&index=0&id=0eb4974a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb4974a",
  null
  
)

export default component.exports